import {Layers as LayersOrigin} from "brigada/src/widget/Layers.js";
/**
 * свой Frame
 */
export class Layers extends LayersOrigin {
	message( sMessageHtml ) {
		this.show( {
			sLayer: 'Popup',
			sFrameId: "message",
			sContent:
		`<div class="popup popup_message">
			<div class="popup__close _ _Btn" data-layer="0">закрыть</div>
			<div>${sMessageHtml}</div>
		</div>`
		} );
	}
}